import { safeJson } from "src/app/helpers/Index";
import { SystemSettingGroupService } from "./SystemSettingGroupService";
import { SystemSettingService } from "./SystemSettingService";

const GROUP_NAME = "Club Settings";
export const CLUB_SETTING_TEAMSHEET_SPONSOR_IMAGE = "TeamsheetSponsorImage";
export const CLUB_SETTING_LEAGUE_IMAGE = "LeagueImage";
export const CLUB_SETTING_NAME = "ClubName";
export const CLUB_SETTING_ADDRESS = "ClubAddress";
export const CLUB_SETTING_GROUND_NAME = "ClubGroundName";
export const CLUB_SETTING_PRIMARY_COLOUR = "ClubPrimaryColour";
export const CLUB_SETTING_SECONDARY_COLOUR = "ClubSecondaryColour";
export const CLUB_SETTING_BADGE = "ClubBadge";
export const CLUB_SETTING_DOMAIN = "ClubDomain";
export const CLUB_SETTING_SOCIAL_FACEBOOK = "ClubSocialFacebook";
export const CLUB_SETTING_SOCIAL_INSTAGRAM = "ClubSocialInstagram";
export const CLUB_SETTING_SOCIAL_BLUESKY = "ClubSocialBluesky";
export const CLUB_SETTING_SOCIAL_LINKEDIN = "ClubSocialLinkedin";
export const CLUB_SETTING_SOCIAL_TWITTER = "ClubSocialTwitter";
export const CLUB_SETTING_SOCIAL_TIKTOK = "ClubSocialTiktok";

/**
 * Club-level settings stored as SystemSettings under a "Club Settings"
 * group (created on first save) - no API changes required.
 */
export const ClubSettingService = {
	get: async (label: string): Promise<string> => {
		return (await ClubSettingService.getMap())[label] || "";
	},

	/** All settings as a label -> value map (one request). */
	getMap: async (): Promise<{ [label: string]: string }> => {
		const settings = await safeJson(SystemSettingService.getAll());
		const map: { [label: string]: string } = {};
		for (const setting of (Array.isArray(settings) ? settings : [])) {
			if (setting.label) map[setting.label] = setting.value || "";
		}
		return map;
	},

	set: async (label: string, value: string): Promise<boolean> => {
		const settings = await safeJson(SystemSettingService.getAll());
		const existing = (Array.isArray(settings) ? settings : []).find((x: any) => x.label === label);
		if (existing) {
			if ((existing.value || "") === value) return true;
			return (await SystemSettingService.updateSingleById(existing.id, { ...existing, value })).ok;
		}

		const groups = await safeJson(SystemSettingGroupService.getAll());
		let group = (Array.isArray(groups) ? groups : []).find((x: any) => x.name === GROUP_NAME);
		if (!group) {
			const created = await SystemSettingGroupService.createSingle({ name: GROUP_NAME } as any);
			if (!created.ok) return false;
			group = await created.json();
		}
		return (await SystemSettingService.createSingle({ label, systemSettingGroupId: group.id, value } as any)).ok;
	},

	/** Saves several settings; returns true when all succeeded. */
	setMany: async (values: { [label: string]: string }): Promise<boolean> => {
		let allOk = true;
		for (const label of Object.keys(values)) {
			if (!(await ClubSettingService.set(label, values[label]))) allOk = false;
		}
		return allOk;
	}
}
